<template>
  <div>
    <v-card class="my-1">
      <v-card-title>CP22A Form</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-row>
            <v-col>
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    label="Start Date"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"  
                    data-vv-as="start date"                     
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="startDateChange"
                />
              </v-menu>
            </v-col>

            <v-col>
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    v-validate="'required'"
                    label="End Date"
                    :disabled="!startDate"
                    :error-messages="errors.collect('endDateDisplay')"
                    data-vv-name="endDateDisplay"  
                    data-vv-as="end date" 
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="endDate"
                  :min="startDate"
                  :max="latestDate"               
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-autocomplete
            v-model="selectedCompanies"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Companies"
            item-text="name"
            item-value="id"
            :items="companies"
            clearable
            multiple
            hide-selected 
            chips
            small-chips
            deletable-chips
            :error-messages="errors.collect('selectedCompanies')"
            data-vv-name="selectedCompanies"  
            data-vv-as="companies"
          />

          <v-col class="mt-2">
            <span> Merge all in one files? </span>
            <v-radio-group
              v-model="isMerged"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="loading" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>
      
          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                color="primary"
                :loading="loading"
                :disabled="employees.length <= 0"
                @click="generateCP22AForm"
              >
                generate
              </v-btn>
            </v-col>
          </v-row>
        </v-col>  
      </v-row>  
    </v-card>
  </div>
</template>

<script>
  export default {  
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        startDateMenu: false,
        startDate: null,
        endDateMenu: false,
        endDate: null,        
        companies: [],
        selectedCompanies: [],
        dropdownLoading: false,
        progressbar: 0,
        isMerged: 0,
        employees: [],        
      }
    },
    computed: {      
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.endDate ? this.$moment(this.endDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },   
      latestDate () {
        if (this.startDate) {
          return this.$moment(this.startDate).endOf('year').format('YYYY-MM-DD')
        }
        return this.$moment().endOf('year').format('YYYY-MM-DD')
      }, 
      computedFilter () {
        if (this.selectedCompanies.length < 1 || !this.startDate || !this.endDate) return

        return `${this.selectedCompanies}|${this.startDate}|${this.endDate}`
      },      
    }, 
    watch: {
      computedFilter: {
        immediate: true,
        handler (newVal) {
          if (newVal) {
            const [newCompanies, newStartDate, newEndDate] = newVal.split('|')
            if (newCompanies !== null && newStartDate !== null && newEndDate !== null) {
              this.fetchCP22AEmployee()
            }
          }
        },
      },
    },  
    created () {
      this.dropdownLoading = true

      this.$api.hrisCompanies().list()
        .then(res => {
          this.companies = _.orderBy(res.data, ['name'], ['asc'])

          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.dropdownLoading = false
        })
    },
    methods: {
      fetchCP22AEmployee () {
        this.employees = []

        this.$api.payrollReports().listCP22AEmployees(this.prepareFormData())
          .then(res => {
            if (res.data.length > 0) {
              res.data.map(data => {
                this.employeeObj = {
                  id: data.companyEmployee.company_employee_uid,
                  name: data.companyEmployee.employee.person.name + ' (' + data.companyEmployee.company.name + ')',
                }
                this.employees.push(this.employeeObj)
                this.employees = _.orderBy(this.employees, ['name'], ['asc'])
              })
            } else {
              this.$snack({ 
                color: 'error',
                message: 'No Records Found', 
              })              
            }
          })
      },      
      startDateChange () {
        this.startDateMenu = false
        this.endDateMenu = false
        this.endDate = this.$moment(this.startDate).endOf('month').format('YYYY-MM-DD')
      },      
      generateCP22AForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.payrollReports().employeeCP22A(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/zip' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'CP22A FORM.zip') 
                link.click()
                this.loading = false
                this.progressbar = 0

                this.$snack({ message: 'CP22A Form downloaded successfully' })
              })
              .catch(error => {
                this.loading = false
                if (error.response.status === 400) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                }
              })
          })
      },
      prepareFormData () {
        return {
          isMerged: this.isMerged,
          start_date: this.startDate,
          end_date: this.endDate,
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies }
      },
    },
  }
</script>
